import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyFormatterService } from '../../services/currency-formatter.service';
import { FeeChargeRow } from '../../models/fee-config';

@Pipe({ name: 'feeFieldChanged', pure: true })
export class FeeFieldChangedPipe implements PipeTransform {
  private readonly currencyFields = new Set(['value', 'minimumValue', 'maximumValue']);

  constructor(private currencyFormatter: CurrencyFormatterService) {}

  transform(currentRow: FeeChargeRow, oldRow: FeeChargeRow | undefined, field: keyof FeeChargeRow): boolean {
    if (!oldRow) return false;
    const oldValue = oldRow[field];
    const newValue = currentRow?.[field];
    if (this.currencyFields.has(field as string)) {
      return this.currencyFormatter.parseCurrency(String(oldValue)) !== this.currencyFormatter.parseCurrency(String(newValue));
    }
    return oldValue !== newValue;
  }
}
